module.exports = __webpack_public_path__ + "assets/img/mecha-36467272.png";